import { render, staticRenderFns } from "./Basico.vue?vue&type=template&id=75c3d6f8&scoped=true&"
import script from "./Basico.vue?vue&type=script&lang=js&"
export * from "./Basico.vue?vue&type=script&lang=js&"
import style0 from "./Basico.vue?vue&type=style&index=0&id=75c3d6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c3d6f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VForm,VSpacer})
